import React, { forwardRef } from "react";
import { Select as ManSelect, SelectProps } from "@mantine/core";
import { useFormField } from "..";
import { mergeClassName } from "@/common/utils/helpers";
import { CgSpinner } from "react-icons/cg";

interface Props extends SelectProps {
  value?: string;
  loading?: boolean;
}

const Select = forwardRef<React.ElementRef<typeof ManSelect>, Props>(
  ({ value, classNames, loading, ...props }, ref) => {
    const formData = useFormField();

    return (
      <ManSelect
        ref={ref}
        {...props}
        classNames={{
          ...classNames,
          input: mergeClassName(
            "h-14 w-full rounded-xl border bg-inputbg py-3 pl-4 text-base leading-none text-black placeholder:text-base placeholder:text-gray-320",
            formData?.error ? "border-red-10" : ""
          ),
        }}
        error={formData?.error ? formData?.error?.message : undefined}
        value={value}
        rightSection={loading && <CgSpinner className="animate-spin" />}
      />
    );
  }
);

Select.displayName = "Select";

export default Select;
